module.exports = __webpack_public_path__ + "img/introductionToStatistics_sign.e7f5d4f3.png";